import { render, staticRenderFns } from "./ui-radio.vue?vue&type=template&id=4da6d871&"
import script from "./ui-radio.vue?vue&type=script&lang=js&"
export * from "./ui-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports